import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Form, FieldArray, reduxForm } from 'redux-form';
import { Link } from 'react-router';

import SortableWrap from './sortable/container';

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = props => {
	return (
		<div className="targeting-form__wrap">
			<Form
				className="ui-form targeting-form__landing"
				onSubmit={props.handleSubmit(formData => props.targetingFromSubmit(formData))}>
				<div className="ui-form__element buttons-wrap">
					{ props.can('edit') && (
						<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
					)}
					<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
				</div>

				<FieldArray
					intl={props.intl}
					can={props.can}
					name="targeting"
					locationsLookups={props.locationsLookups}
					affiliatesLookups={props.affiliatesLookups}
					initialValues={props.initialValues}
					remove={props.targetingDelete}
					activeCheckboxStates={props.activeCheckboxStates}
					activePayoutCurrencies={props.activePayoutCurrencies}
					rotateActiveCheckbox={props.rotateActiveCheckbox}
					component={RenderFieldArray}
				/>

				<div className="ui-form__element buttons-wrap">
					{ props.can('edit') && (
						<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
					)}
					<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
				</div>
			</Form>
		</div>
	);
};

const RenderFieldArray = (props) => (
	<div className="fields-wrap">
		{ props.can('edit') && (
			<div className="fields-wrap__add" onClick={() => props.fields.unshift(isRocket ? {
				competence_percent: '20',
				form_boost_value: '20',
				is_own_callcenter: true,
				is_contest_enabled: true,
				is_booster_available: false
			} : {})}>
				<span className="fields-wrap__add-title">{props.intl('Add targeting')}</span>
			</div>
		)}
		<div className="fields-wrap__list">
			{ props.fields.length > 0 && (
				<SortableWrap {...props}
					useDragHandle={true}
					lockToContainerEdges={true}
					lockAxis={'y'}
					onSortEnd={sortProps => {
						const { oldIndex, newIndex } = sortProps;
						props.fields.move(oldIndex, newIndex);
					}}/>
			) }
		</div>
	</div>
);

Main.propTypes = {
	locationsLookups: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	handleSubmit: PropTypes.func,
	targetingFromSubmit: PropTypes.func,
	targetingDelete: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	initialValues: PropTypes.object,
	activeCheckboxStates: PropTypes.array,
	rotateActiveCheckbox: PropTypes.func
};

RenderFieldArray.propTypes = {
	locationsLookups: PropTypes.func,
	fields: PropTypes.object,
	title: PropTypes.string,
	langs: PropTypes.array,
	remove: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	initialValues: PropTypes.object
};

export default connect(state => ({
	isCommentFormVisible: state.programsEditor.targetingForm.isCommentFormVisible
}))(reduxForm({
	form: 'programsTargetingForm'
})(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/targeting/main.js